// The text that goes with a link holding times for a patient.
//
// One message, not three: Allison did not want the practice to look like it
// was spamming. One link, not one per time: the page behind it shows only
// what this link holds. The wording itself is in offerMessage.ts.
import { heldOfferText, OfferSlot } from './offerMessage';
import { getPracticeTimeZone } from '../../utils/practiceTime';

// How long a link lives, as a person would say it. Still used to fill
// {expires} in the wellness outreach template, which is the practice's own
// wording. The offer text itself now gives the real deadline instead.
/**
 * How many days a booking link holds its times: the practice's choice of one,
 * two or three (Admin › Settings › Booking Links), and one for anything else —
 * the same rule the server applies when it creates the link.
 */
export function holdDays(setting: unknown): number {
  const days = Number(setting);
  return [1, 2, 3].includes(days) ? days : 1;
}

export function linkLifetimePhrase(ttlDays?: number | null): string {
  const days = Number(ttlDays);
  if (!Number.isFinite(days) || days <= 0) return 'in a week';
  if (days === 1) return 'tomorrow';
  if (days === 7) return 'in a week';
  if (days === 14) return 'in two weeks';
  return `in ${days} days`;
}

export interface HeldOffer {
  patientName: string;
  slots: OfferSlot[];
  url: string;
  /** When the link stops working — the deadline the patient is told. */
  expiresAt?: string | Date | null;
  /** The practice's own wording, from Admin; blank means the standard one. */
  template?: string | null;
  timeZone?: string;
}

export function heldOfferMessage({ patientName, slots, url, expiresAt, template, timeZone }: HeldOffer): string {
  return heldOfferText({ patientName, slots, url, expiresAt, template, timeZone: timeZone || getPracticeTimeZone() });
}
